import {
  GET_TOTAL_PURCHASES,
  GET_TOTAL_PURCHASES_SUCCESS,
  GET_TOTAL_PURCHASES_ERROR,
  GET_AVERAGE_PAY,
  GET_AVERAGE_PAY_ERROR,
  GET_AVERAGE_PAY_SUCCESS
} from './SummarySection.actions'

const totalPurchasesState = {
  loading: true,
  error: undefined,
  rangeDate: {
    initialMonth: null,
    initialYear: null,
    finalMonth: null,
    finalYear: null
  },
  totalPurchaseAmount: 0
}
const averagePayState = {
  loading: true,
  error: undefined,
  days: null,
  sigfe: false,
  updateAt: null,
  rangeDate: {
    initialMonth: null,
    initialYear: null,
    finalMonth: null,
    finalYear: null
  }
}

/**
 * The Summary Section reducer.
 */
const totalPurchasesReducer = (state = totalPurchasesState, { payload, type }) => {
  switch (type) {
    case GET_TOTAL_PURCHASES: {
      return { ...state, loading: true }
    }
    case GET_TOTAL_PURCHASES_SUCCESS: {
      return {
        ...state,
        loading: false,
        totalPurchaseAmount: payload?.totalPurchaseAmount,
        rangeDate: payload?.rangeDate
      }
    }
    case GET_TOTAL_PURCHASES_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    default: {
      return state
    }
  }
}

/**
 * The average pay Section reducer.
 */
const averagePayReducer = (state = averagePayState, { payload, type }) => {
  switch (type) {
    case GET_AVERAGE_PAY: {
      return { ...state, loading: true }
    }
    case GET_AVERAGE_PAY_SUCCESS: {
      return {
        ...state,
        loading: false,
        days: payload.days,
        updatedAt: payload.updatedAt,
        sigfe: payload.sigfe,
        rangeDate: payload.rangeDate
      }
    }
    case GET_AVERAGE_PAY_ERROR: {
      return { ...state, loading: false, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export { totalPurchasesReducer, averagePayReducer }
